var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stethoscope"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8050_71304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8050_71304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stethoscope_2",
    d: "M11.2501 18.3327C9.75008 18.3327 8.4723 17.8049 7.41675 16.7493C6.36119 15.6938 5.83341 14.416 5.83341 12.916V12.4368C4.63897 12.2424 3.64591 11.6834 2.85425 10.7598C2.06258 9.83615 1.66675 8.74935 1.66675 7.49935V2.49935H4.16675V1.66602H5.83341V4.99935H4.16675V4.16602H3.33341V7.49935C3.33341 8.41602 3.6598 9.20074 4.31258 9.85352C4.96536 10.5063 5.75008 10.8327 6.66675 10.8327C7.58341 10.8327 8.36814 10.5063 9.02091 9.85352C9.67369 9.20074 10.0001 8.41602 10.0001 7.49935V4.16602H9.16675V4.99935H7.50008V1.66602H9.16675V2.49935H11.6667V7.49935C11.6667 8.74935 11.2709 9.83615 10.4792 10.7598C9.68758 11.6834 8.69453 12.2424 7.50008 12.4368V12.916C7.50008 13.9577 7.86466 14.8431 8.59383 15.5723C9.323 16.3014 10.2084 16.666 11.2501 16.666C12.2917 16.666 13.1772 16.3014 13.9063 15.5723C14.6355 14.8431 15.0001 13.9577 15.0001 12.916V11.5202C14.514 11.3535 14.1147 11.0549 13.8022 10.6243C13.4897 10.1938 13.3334 9.70768 13.3334 9.16602C13.3334 8.47157 13.5765 7.88129 14.0626 7.39518C14.5487 6.90907 15.139 6.66602 15.8334 6.66602C16.5279 6.66602 17.1181 6.90907 17.6042 7.39518C18.0904 7.88129 18.3334 8.47157 18.3334 9.16602C18.3334 9.70768 18.1772 10.1938 17.8647 10.6243C17.5522 11.0549 17.1529 11.3535 16.6667 11.5202V12.916C16.6667 14.416 16.139 15.6938 15.0834 16.7493C14.0279 17.8049 12.7501 18.3327 11.2501 18.3327Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.4c15c4f27f5519ba8d6d8bb83e835de7.svg";
export { ForwardRef as ReactComponent };